module.exports = __webpack_public_path__ + "static/media/close-24px.52bd8432.svg";